import React, { useEffect, useState } from 'react';
import {
  Heading,
  Stack,
  Text,
  Flex,
  keyframes,
  Image,
  Circle,
  useColorModeValue,
  Icon,
  Link,
} from '@chakra-ui/react';
import AnimatedPage from './Other/AnimatedPage';
import Typewriter from 'typewriter-effect';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import try1 from '../Images/try1.jpg'

const HomePage = ({ loading }) => {
  const colorModeValueReverted = useColorModeValue('#1b202c', '#edeeee');
  const colorModeValue = useColorModeValue('#edeeee', '#1b202c');
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {

    const arrowTimer = setTimeout(
      () => {
        setShowArrow(true);
      },
      loading ? 4200 : 2300
    );

    return () => {
      clearTimeout(arrowTimer);
    };
  }, [loading]);

  const arrowAnim = keyframes`
   0% {
    transform: translate(0px,0)
   }

   50% {
    transform: translate(12px,0)
   }

   100% {
    transform: translate(0px,0)
   }
  `;

  const animation = {
    initial: { opacity: 0, x: -150 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
  };

  const shine = keyframes`
  from {
    background-position: right bottom;
  }
  to {
    background-position: left bottom;
  }
  `;

  return (
    <>
      <AnimatedPage>
        <Flex
          direction={['column', 'column', 'row', 'row']}
          w={'100%'}
          mx="auto"
          alignItems={{ md: 'center', lg: 'center' }}
          justifyContent={'space-between'}
          mt={'4rem'}
        >
          <Flex
            justifyContent={[
              'center',
              'center',
              'center',
              'flex-start',
              'flex-start',
              'flex-start',
            ]}
          >
            <Stack spacing={'1.2rem'}>
              <Heading as={'h1'} size={['xl', 'xl', '2xl', '2xl']}>
                Hi, I'm{' '}
                <Heading
                  as={'span'}
                  // animation={`${animation} infinite 3s`}
                  size={['xl', 'xl', '2xl', '2xl']}
                  background={`linear-gradient(to right, #417fcc 50%, ${colorModeValueReverted} 50%)`}
                  backgroundSize={'200% 100%'}
                  backgroundPosition={'left bottom'}
                  css={{
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                  transition={'all .5s ease-out'}
                  animation={`${shine} 2.5s 1 linear`}
                  _hover={{ backgroundPosition: 'right bottom' }}
                >
                  Lior Reuven
                </Heading>
              </Heading>
              <Heading
                fontWeight={'semibold'}
                as={'h2'}
                size={['md', 'md', 'xl', 'xl']}
              >
                Web Developer
              </Heading>
              <Text as={'h3'} fontSize={['lg', 'lg', '2xl', '2xl']}>
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .changeDelay(75)
                      .typeString(`Click the arrow below to read about me`)
                      .start();
                  }}
                />
              </Text>
            </Stack>
          </Flex>
          <Flex
            justifyContent={[
              'center',
              'center',
              'center',
              'flex-end',
              'flex-end',
              'flex-end',
            ]}
          >
            <Image
              mt={['80px', '80px', '0', '0']}
              boxSize={['120px', '120px', '150px', '200px']}
              borderRadius={'full'}
              backgroundColor={'white'}
              boxShadow={'lg'}
              objectFit={'cover'}
              src={try1}
            />
          </Flex>
        </Flex>
        <Flex minH={'90px'} mt={'4rem'} justifyContent={'center'} w={'100%'}>
          {showArrow && (
            <Link as={RouterLink} to={'/about'}>
            <motion.div
              variants={animation}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 2, type: 'spring', bounce: 0.4 }}
            >
              <Circle _hover={{backgroundColor: '#417fcc'}} size={['75px','75px','75px','90px','90px','90px']} backgroundColor={colorModeValueReverted}>
                <Flex justifyContent={'center'} w={'100%'}>
                  <Icon
                    w={'100%'}
                    animation={`${arrowAnim} 1.2s  ease-in-out infinite`}
                    as={FaArrowRight}
                    boxSize={[10,10,10,12,12,12]}
                    color={colorModeValue}
                  ></Icon>
                </Flex>
              </Circle>
            </motion.div>
            </Link>
          )}
        </Flex>
      </AnimatedPage>
    </>
  );
};

export default HomePage;
